import { useEffect, useRef } from 'react';

/**
 * Hook que executa um effect uma única vez ao montar o componente.
 * Evita a duplicação de requisições causada pelo React 18 StrictMode em desenvolvimento.
 * 
 * @param effect Função a ser executada uma única vez
 * @example
 * useInitEffect(() => {
 *   storeService.getProfile().then(setProfile);
 * });
 */
export function useInitEffect(effect: () => void | (() => void)) {
  const executedRef = useRef(false);

  useEffect(() => {
    if (executedRef.current) return;
    executedRef.current = true;

    const cleanup = effect();
    
    return () => {
      if (typeof cleanup === 'function') {
        cleanup();
      }
    };
  }, [effect]);
}
